import { DeadlineMonthTypeEnum } from '@zaoblako/shared/common/enums/deadline.month.type.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';

/** Localized human-readable display names for {@link DeadlineMonthTypeEnum} enumeration values */
export const DeadlineMonthTypeEnumI18n: Record<I18nLocalesEnum, Record<DeadlineMonthTypeEnum, string>> = {
  [I18nLocalesEnum.RU_RU]: {
    [DeadlineMonthTypeEnum.CURRENT]: 'Текущий',
    [DeadlineMonthTypeEnum.NEXT]: 'Следующий',
  },
  [I18nLocalesEnum.EN_US]: {
    [DeadlineMonthTypeEnum.CURRENT]: 'Current',
    [DeadlineMonthTypeEnum.NEXT]: 'Next',
  },
};
